import {
  RECEIVE_OV_TIME_SERIES,
  REQUEST_OV_TIME_SERIES
} from "../actions/usage";
import moment from "moment";
import { sortByKey } from "../helpers/presentation";

function timeSeries(state = { data: [], loading: false }, action) {
  switch (action.type) {
    case REQUEST_OV_TIME_SERIES:
      return Object.assign({}, state, { loading: true });
    case RECEIVE_OV_TIME_SERIES:
      return {
        data: sortByKey(
          action.data.map(d => ({
            ...d,
            start_time: moment.utc(d.start_time)
          })),
          "start_time"
        ),
        loading: false
      };
    default:
      return state;
  }
}

export default timeSeries;



// WEBPACK FOOTER //
// ./src/reducers/overviewTimeSeries.js